import React from 'react';
import { AlertTriangle, Trash2, X } from 'lucide-react';
import styles from './FileDeleteConfirmModal.module.css';

function FileDeleteConfirmModal({ onClose, onConfirm, fileName, isDeleting = false }) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.warningIcon}>
              <AlertTriangle className="h-4 w-4" />
            </div>
            <h2 className={styles.headerTitle}>Delete File</h2>
          </div>
          <p className={styles.warningText}>
            Are you sure you want to delete "<strong className={styles.fileName}>{fileName}</strong>"? 
            This action cannot be undone and will permanently remove the file from your project.
          </p>
        </div>

        <div className={styles.footer}>
          <button
            type="button"
            onClick={onClose}
            disabled={isDeleting}
            className={styles.cancelButton}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className={styles.deleteButton}
          >
            {isDeleting ? (
              <>
                <div className={styles.loadingSpinner}></div>
                Deleting...
              </>
            ) : (
              <>
                <Trash2 className="h-4 w-4 mr-2" />
                Delete File
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FileDeleteConfirmModal; 